import React from "react";
import { FaHome, FaBuilding, FaBoxOpen, FaWarehouse, FaTv, FaTruckLoading } from "react-icons/fa";
import "./allServices.css";

const services = [
  { title: "Home Relocation", icon: <FaHome /> },
  { title: "Office Relocation", icon: <FaBuilding /> },
  { title: "Loading & Unloading", icon: <FaTruckLoading /> },
  { title: "Packing & Unpacking", icon: <FaBoxOpen /> },
  { title: "Storage Solutions", icon: <FaWarehouse /> },
  { title: "AC & TV Installation", icon: <FaTv /> },
];

export function AllServices() {
  return (
    <div className="services-container">
      {services.map((service, index) => (
        <div className="service-card" key={index}>
          <div className="service-icon">{service.icon}</div>
          <h3 className="service-title">{service.title}</h3>
        </div>
      ))}
    </div>
  );
}
